import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const CAT_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.CAT,
  title: 'COPD Assessment Test (CAT)',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: [
      'tosse',
      'catarro',
      'oppressione',
      'fiato',
      'attivita',
      'fiducia',
      'sonno',
      'energia',
    ],
  },
  sections: [
    {
      name: 'cat',
      label: 'COPD Assessment Test',
      fields: [
        {
          key: 'tosse',
          label: 'Tosse',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description: 'Valuta la frequenza e intensità della tosse.',
          valueDescriptions: {
            '0': 'Nessuna tosse.',
            '5': 'Tosse molto intensa.',
          },
        },
        {
          key: 'catarro',
          label: 'Catarro / Muco',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description: 'Valuta la quantità di muco prodotto.',
          valueDescriptions: {
            '0': 'Nessun muco.',
            '5': 'Muco molto abbondante.',
          },
        },
        {
          key: 'oppressione',
          label: 'Oppressione toracica',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description: 'Sensazione di costrizione o peso sul torace.',
          valueDescriptions: {
            '0': 'Nessuna oppressione.',
            '5': 'Oppressione molto intensa.',
          },
        },
        {
          key: 'fiato',
          label: 'Fiato corto durante attività',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description: 'Valuta la mancanza di fiato durante il movimento.',
          valueDescriptions: {
            '0': 'Nessuna difficoltà.',
            '5': 'Fiato molto corto anche con piccoli sforzi.',
          },
        },
        {
          key: 'attivita',
          label: 'Limitazioni nelle attività quotidiane',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description:
            'Quanto la respirazione limita le attività di tutti i giorni.',
          valueDescriptions: {
            '0': 'Nessuna limitazione.',
            '5': 'Molto limitato/a nelle attività quotidiane.',
          },
        },
        {
          key: 'fiducia',
          label: 'Fiducia e gestione della malattia',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description:
            "Percezione di controllo e fiducia nell'affrontare la malattia.",
          valueDescriptions: {
            '0': 'Mi sento sicuro/a.',
            '5': 'Mi sento molto insicuro/a.',
          },
        },
        {
          key: 'sonno',
          label: 'Qualità del sonno',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description: 'Influenza dei sintomi respiratori sul sonno.',
          valueDescriptions: {
            '0': 'Sonno normale.',
            '5': 'Sonno molto disturbato.',
          },
        },
        {
          key: 'energia',
          label: 'Livello di energia',
          type: 'number',
          min: 0,
          max: 5,
          step: 1,
          maxScore: 5,
          description: 'Livello generale di energia/vitalità.',
          valueDescriptions: {
            '0': 'Mi sento molto energico/a.',
            '5': 'Mi sento senza energie.',
          },
        },
      ],
    },
  ],
  computedFields: [
    {
      key: 'interpretazione',
      label: 'Impatto clinico della BPCO',
      type: 'text',
      calculation: `
        IF(totale <= 10, "Low impact (basso impatto dei sintomi)",
          IF(totale <= 20, "Medium impact (impatto moderato)",
            IF(totale <= 30, "High impact (impatto elevato)",
              "Very high impact (impatto molto elevato)"
            )
          )
        )
      `,
      maxScore: 30,
    },
  ],
};
